import { Component } from 'react';
import PropTypes from 'prop-types';
import { DragHeightCom } from '@platform/components';
import CompMeta from '../../meta/LowCodeComponents/DragHeightCom';

/**
 * @class NCDragHeightCom
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCDragHeightCom
 * @label 上下分栏
 *
 */
class NCDragHeightCom extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title defLeftWid
         * @description 左侧宽度
         */
        defTopHeight: PropTypes.string,
        /**
         * @title leftMinWid
         * @description 左侧最小宽度
         */
        topMinHeight: PropTypes.string,
        /**
         * @title leftDom
         * @description 左侧栏目
         */
        topDom: PropTypes.node,
        /**
         * @title rightDom
         * @description 右侧栏目
         */
        bottomDom: PropTypes.node,
        /**
        * @title 是否可见
        * @description 是否可见
        */
        visible: PropTypes.bool,
    }
    static defaultProps = {
        defTopHeight: '150px',
        topMinHeight: '50px'
    }
    static getCompMeta() {
        return CompMeta;
    }

    render() {
        return (
            <DragHeightCom {...this.props} className="lc-drop-area" />
        )
    }
}
export default NCDragHeightCom;
